import { t } from 'i18next'
import React from 'react'
import { Divider, Dropdown, Icon, Popup } from 'semantic-ui-react'
import { useAuth } from '~/routes/components/AuthProvider'
import { El } from './style'

const Support: React.FC = () => {
  const { supportData } = useAuth()

  return <Dropdown
    icon={<Popup
      content={supportData?.tooltip}
      trigger={<Icon size='large' style={{ color: 'white' }} name={supportData?.icon} />}
    />
    }
  >
    <Dropdown.Menu>
      <El.StyledSupportWrapper>
        {Boolean(supportData?.descriptionStatus) && <div style={{ margin: 10, fontStyle: 'italic', whiteSpace: 'break-spaces' }}>
          {supportData?.description || ''}
        </div>}
        <Divider />
        {Boolean(supportData?.emailStatus) && <div style={{ margin: 20 }}>
          <div style={{ marginBottom: 10 }}>{t('Email')}</div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon name='mail' />
            <a href={`mailto:${supportData?.email}`}>{supportData?.email || ''}</a>
          </div>
          <Divider />
        </div>
        }
        {Boolean(supportData?.phoneStatus) && <div style={{ margin: 20 }}>
          <div style={{ marginBottom: 10 }}>{t('Phone number')}</div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Icon name='phone' />
            <div>{`${supportData?.phoneCode || ''} ${supportData.phoneNumber || ''}`}</div>
          </div>
          <Divider />
        </div>}
        {Boolean(supportData?.faxStatus) && <>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 10 }}>{t('Telefax number')}</div>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Icon name='fax' />
              <div>{`${supportData?.faxCode || ''} ${supportData.faxNumber || ''}`}</div>
            </div>
          </div>
          <Divider />
        </>}
        {Boolean(supportData?.footerDescriptionStatus) && <div style={{ margin: 10, textAlign: 'center', whiteSpace: 'break-spaces' }}>
          {supportData?.footerDescription || ''}
        </div>}
      </El.StyledSupportWrapper>
    </Dropdown.Menu>
  </Dropdown>
}
export default Support